import { fetchPOST } from "../Tools";

export class User {

    constructor() {
        document.querySelectorAll('.btn-reset-fail').forEach((resetBtn: HTMLElement) => {
            resetBtn.addEventListener('click', (ev) => this.resetLoginFailCounter(ev, resetBtn));
        });
    }

    async resetLoginFailCounter(ev: Event, resetBtn: HTMLElement) {
        const state = await fetchPOST('/Handler/User/UserReset', {
            'id' : resetBtn.dataset.id
        });
        if(state) {
            resetBtn.remove();
            window.tools.toast('Nutzerverwaltung', 'Der Zähler wurde zurück gesetzt');
        } else {
            window.tools.toast('Nutzerverwaltung', 'Beim zurücksetzen des Zählers ist ein Fehler aufgetreten');
        }
    }
}
